import { PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
import VueTour from 'vue-tour';
import Vuesax from 'vuesax';
import { i18n } from '@/i18n';
import '@/i18n/vendors';
import { pinia } from '@/pinia';
import App from './App.vue';
import { UI_COLORLS } from './constants';
// Vuesax Component Framework
import 'material-icons/iconfont/material-icons.css'; // Material Icons
import 'vuesax/dist/vuesax.css';
// Globally Registered Components
import './plugins/globalComponents';
// Globally Registered Directives
import './plugins/directive';
// Styles: SCSS
import './assets/scss/main.scss';
// Tailwind
import '@/assets/css/main.css';
// Vue Router
import router from './router';
// Vuex Store
import store from './store/store';
// Filters
import './plugins/filters';
// design tokens
import '@kolesa-group/design-tokens/index.css';

// Цвета темы Vuesax
Vue.use(Vuesax, {
    theme: {
        colors: {
            danger:    '#EA5455',
            dark:      '#1E1E1E',
            link:      '#2a81dd',
            primary:   UI_COLORLS.bluePrimary,
            secondary: '#2a81dd',
            success:   '#28C76F',
            warning:   '#FF9F43',
        },
    },
});
Vue.use(VueTour);
Vue.use(PiniaVuePlugin);

Vue.config.productionTip = false;

new Vue({
    i18n,
    pinia,
    render: h => h(App),
    router,
    store,
}).$mount('#app');
